import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import UserAuthSignin from './user-auth-signin.component';
import UserAuthSignout from './user-auth-signout.component';
import UserAuthSignup from './user-auth-signup.component';
import UserAuthProfile from './user-auth-profile.component';
import UserAuthManageUser from './user-auth-manageuser.component';
import UserAuthChangePassword from './user-auth-changepassword.component';
import UserAuthForgotPassword from './user-auth-forgotpassword.component';
import UserAuthResetPassword from './user-auth-resetpassword.component';
import UserAuthConfirmationEmail from './user-auth-confirmationemail.component';
import UserAuthSendConfirmationEmail from './user-auth-sendconfirmationemail.component';
import UserAuthActivity from './user-auth-activity.component';

interface Props {
  root?: string;
  isSignin?: boolean;
}

export const UserRouteAuth: React.FunctionComponent<Props> = (props) => {
  
  return (
    <Switch>
      {props.isSignin?
      <Switch>
      <Route path={(props.root||'') + '/usersignout'} component={UserAuthSignout} />
      <Route path={`${props.root||''}/userprofile`} render={(params) => <UserAuthProfile {...params} root={props.root}/>} />        
      <Route path={(props.root||'') + '/usermanageuser'} component={UserAuthManageUser} />
      <Route path={(props.root||'') + '/userchangepassword'} component={UserAuthChangePassword} />
      <Route path={(props.root||'') + '/userresetpassword/:code'} component={UserAuthResetPassword} />
      <Route path={(props.root||'') + '/usersendconfirmationemail/:code'} component={UserAuthSendConfirmationEmail} />
      <Route path={`${props.root||''}/useractivity`} component={UserAuthActivity} />
      </Switch>
      :
      <Switch>
      <Route path={(props.root||'') + '/usersignin'} component={UserAuthSignin} />
      <Route path={(props.root||'') + '/usersignup'} component={UserAuthSignup} />
      <Route path={(props.root||'') + '/userforgotpassword'} component={UserAuthForgotPassword} />
      <Route path={(props.root||'') + '/userconfirmationemail/:code'} component={UserAuthConfirmationEmail} />
      </Switch>
      }
    </Switch>
  );
}
